import type { FaireProductEntity } from "../../entity_types/product";

export const p_4fp3n3fvr4: FaireProductEntity = {
  token: "p_4fp3n3fvr4",
  type: "product",
  name: "Spooky Halloween Gemstone Headband - Mommy and Me",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/4d333edf487eb218de68d100060da8e0c219f69b7ba940828c7be6e642873d98.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ff1909ea9796072d2e8f5f55e4a44ad96458b48e5ff939919615d724531ed670.jpeg",
  ],
  priceDollars: 15,
  description:
    "The Spooky Halloween Gemstone Headband is the perfect hair accessory for celebrating Halloween.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬:\n• Pink ribbed knit fabric with black and silver rhinestones and ghost embellishments\n• Satin lined headband\n• Ages 7+ (including adults)\n\nPair this headband with a matching girl's headband and shirt for the perfect mommy & me moment!",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:44:28.679Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
